module.exports = __webpack_public_path__ + "static/impulso-bayer-1-96c853f22ab438d77f6d796c1504ba1b.jpg";